import { useEffect, useState } from 'react'
import { withFormsy } from 'formsy-react'
import classnames from 'classnames'
import Input from 'shared/components/Textfield'

// Pattern here is used due a reason, that Formsy built in validation doesn't work before actually focusing on the field
const FormsyInput = ({
    autoComplete,
    onPaste,
    errorMessage,
    setValue,
    uppercase,
    onChange,
    placeholder,
    label,
    name,
    value,
    hasValue,
    type = 'text',
    validationError,
    required,
    maxLength,
    autoFocus,
    readOnly,
    disabled,
    className = '',
    pattern,
    avoidErrorOnReset,
    onFocus,
    onBlur,
    enterSymbolsValidation,
    regex,
    iconRight,
    onRightIconClickHandler,
    onKeyDown,
    id,
    isValid,
    isPristine,
    isFormSubmitted,
    showSubmitErrors,
}) => {
    const [showError, setShowError] = useState(!isPristine)
    // Errors are revealed on blur, or as soon as the customer has attempted to submit the form
    const revealErrors = showError || isFormSubmitted || showSubmitErrors
    const hasError = revealErrors && !isValid

    const showRequiredError = revealErrors && required && hasValue && validationError
    /* This is a workaround to handle errors on form submit, as formsy can't handle it.
     * If form gets reset, then all inputs fallback to value specified in ´value´ prop
     * If input value is deleted by Formsy reset action, then onBlur function (which enables error showing) is not called
     * and we set showError to false.
     * ´value´ must be set to empty string and ´avoidErrorOnReset´ prop defined for this to work
     * However if you supply input value via ´value´ prop, then this might need additional improvements.
     */
    useEffect(() => {
        if (avoidErrorOnReset && !value) {
            setShowError(false)
        }
    }, [value])

    const changeValue = event => {
        if (onChange) {
            onChange(event)
        }
        setValue(event.currentTarget.value)
    }

    const handleBlur = () => {
        !isValid && setShowError(true)
        if (onBlur) onBlur()
    }

    const onInputHandler = e => {
        if (uppercase) {
            e.target.value = `${e.target.value}`.toUpperCase()
        }
    }

    return (
        <div className={classnames('form-group', className)}>
            <Input
                status={hasError ? 'error' : undefined}
                disabled={disabled}
                readOnly={readOnly}
                required={required}
                type={type || 'text'}
                name={name}
                placeholder={placeholder}
                label={label}
                id={id}
                onChange={changeValue}
                value={value || ''}
                onBlur={handleBlur}
                onFocus={onFocus}
                onInput={onInputHandler}
                onPaste={onPaste}
                autoComplete={autoComplete}
                maxLength={maxLength}
                autoFocus={autoFocus}
                pattern={pattern}
                regex={regex}
                onKeyDown={onKeyDown}
                enterSymbolsValidation={enterSymbolsValidation}
                setShowError={setShowError}
                iconRight={iconRight}
                onRightIconClickHandler={onRightIconClickHandler}
            />
            {showRequiredError ? (
                <span className="text-small text-red">{validationError}</span>
            ) : (
                hasError && (
                    <span className="text-small text-red">
                        {enterSymbolsValidation ? validationError : errorMessage}
                    </span>
                )
            )}
        </div>
    )
}

export default withFormsy(FormsyInput)
